import API from "./axios";

export const contractorApi = {
  getAll:    ()        => API.get("/contractors"),
  // Phase 36da.99.csearch — server-side pagination + sort + flexible search.
  // params: { page, size, sortBy, sortDir, q, active }
  paged:     (params = {}) => API.get("/contractors/paged", { params }),
  getById:   (id)      => API.get(`/contractors/${id}`),
  create:    (data)    => API.post("/contractors", data),
  update:    (id, d)   => API.put(`/contractors/${id}`, d),
  delete:    (id)      => API.delete(`/contractors/${id}`),
};

export const contractorTypeApi = {
  getAll:    ()        => API.get("/contractor-types"),
  getActive: ()        => API.get("/contractor-types/active"),
  create:    (data)    => API.post("/contractor-types", data),
  update:    (id, d)   => API.put(`/contractor-types/${id}`, d),
  delete:    (id)      => API.delete(`/contractor-types/${id}`),
};

export const contractorIssueApi = {
  // locationId (optional) — only that location's issues (Contractor Inward's picker).
  getAll:        (locationId) => API.get("/contractor-issues", { params: locationId ? { locationId } : {} }),
  // Phase 5 — server-side pagination + sort + search.
  // params: { page, size, sortBy, sortDir, q, status, contractorId, contractorTypeId, locationId }
  paged:         (params = {}) => API.get("/contractor-issues/paged", { params }),
  // Phase 36da.65 — accept contractorTypeId so each contractor type
  // (Stitching / Embroidery / Pressing …) tracks its own remaining
  // quantities.  Without the param the backend returns legacy
  // company-wide totals.  Mirrors deptIssueApi.getSoRemaining(deptId).
  // locationId (optional) — remaining = that location's share of the SO less
  // what that location has issued.
  getSoRemaining: (contractorTypeId, locationId) => API.get("/contractor-issues/so-remaining", {
    params: { contractorTypeId: contractorTypeId || undefined, locationId: locationId || undefined }
  }),
  getById:   (id)      => API.get(`/contractor-issues/${id}`),
  // data.locationId (optional) — where the work goes out from; omitted = the login's default.
  create:    (data)    => API.post("/contractor-issues", data),
  update:    (id, d)   => API.put(`/contractor-issues/${id}`, d),
  issue:     (id)      => API.patch(`/contractor-issues/${id}/issue`),
  cancel:    (id)      => API.patch(`/contractor-issues/${id}/cancel`),
  // Phase 36da.99.dd — delete a DRAFT contractor issue.
  deleteDraft: (id)    => API.delete(`/contractor-issues/${id}`),
  pendingInward: (contractorId) => API.get(`/contractor-issues/pending-inward?contractorId=${contractorId}`),
  calculateRequirements: (productId, soItemId, qty) =>
    API.get(`/contractor-issues/calculate-requirements?productId=${productId}&soItemId=${soItemId}&qty=${qty}`),
};

export const contractorInwardApi = {
  // locationId (optional) — only that location's inwards. An inward's location
  // is derived on the server from its issues.
  getAll:    (locationId) => API.get("/contractor-inwards", { params: locationId ? { locationId } : {} }),
  // Phase 5 — server-side pagination + sort + search.
  // params: { page, size, sortBy, sortDir, q, status, contractorId, locationId }
  paged:     (params = {}) => API.get("/contractor-inwards/paged", { params }),
  getByIssue:(issueId)  => API.get(`/contractor-inwards/by-issue/${issueId}`),
  getById:   (id)       => API.get(`/contractor-inwards/${id}`),
  create:    (data)     => API.post("/contractor-inwards", data),
  update:    (id, d)    => API.put(`/contractor-inwards/${id}`, d),
  confirm:   (id)       => API.patch(`/contractor-inwards/${id}/confirm`),
  cancel:    (id)       => API.patch(`/contractor-inwards/${id}/cancel`),
  // Phase 36da.99.dd — delete a DRAFT contractor inward.
  deleteDraft: (id)     => API.delete(`/contractor-inwards/${id}`),
};

export const contractorInvoiceApi = {
  getAll:         ()           => API.get("/contractor-invoices"),
  // Phase 5 — server-side pagination + sort + search.
  // params: { page, size, sortBy, sortDir, q, status, contractorId }
  paged:          (params = {}) => API.get("/contractor-invoices/paged", { params }),
  getById:        (id)         => API.get(`/contractor-invoices/${id}`),
  create:         (data)       => API.post("/contractor-invoices", data),
  updateStatus:   (id, status) => API.patch(`/contractor-invoices/${id}/status?status=${status}`),
};